import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../utils/api.constants';
import { TenantAzureAdConfig, UpsertTenantAzureAdConfig } from '../models/tenant-sso.model';

@Injectable({
  providedIn: 'root'
})
export class TenantSsoService {

  constructor(private http: HttpClient) { }

  getAzureAdConfig(tenantUid: string): Observable<TenantAzureAdConfig> {
    return this.http.get<TenantAzureAdConfig>(API_ENDPOINTS.TENANTS.AZURE_AD(tenantUid));
  }

  saveAzureAdConfig(tenantUid: string, payload: UpsertTenantAzureAdConfig): Observable<TenantAzureAdConfig> {
    return this.http.put<TenantAzureAdConfig>(API_ENDPOINTS.TENANTS.AZURE_AD(tenantUid), payload);
  }
}
